import { FlexCol, FlexRow } from '@/src/components'
import { BaseText } from '@/src/components/BaseText'
import { InformationTooltip } from '@/src/components/InformationTooltip'
import { appColors } from '@/src/theme/foundations/colors'
import { Box, type BoxProps } from '@chakra-ui/react'
import type { FC, ReactNode } from 'react'

interface KPIBoxV2Props extends BoxProps {
  children: ReactNode
}

interface TitleProps {
  children: ReactNode
  tooltip?: string
}

interface BigValueProps {
  children: ReactNode
}

interface ExtraProps {
  children: ReactNode
}

interface KPIBoxV2SubComponents {
  Title: FC<TitleProps>
  BigValue: FC<BigValueProps>
  Extra: FC<ExtraProps>
}

export const KPIBoxV2: FC<KPIBoxV2Props> & KPIBoxV2SubComponents = ({ children, ...boxProps }) => {
  return (
    <Box borderRadius={'0.25rem'} border='1px solid' borderColor='border' backgroundColor='background' padding={2} {...boxProps}>
      <FlexCol gap='4px'>{children}</FlexCol>
    </Box>
  )
}

KPIBoxV2.Title = ({ children, tooltip }) => {
  return (
    <FlexCol gap='0.5rem' marginBottom='0.25rem'>
      <FlexRow gap='0.5rem' alignItems='center'>
        <BaseText variant='default' color={appColors.secondaryForeground} whiteSpace='nowrap'>
          {children}
        </BaseText>
        {tooltip && <InformationTooltip label={tooltip} />}
      </FlexRow>
    </FlexCol>
  )
}

KPIBoxV2.BigValue = ({ children }) => {
  return (
    <FlexCol marginBottom='1rem'>
      <BaseText whiteSpace='nowrap' fontSize='20px' fontWeight='116'>
        {children}
      </BaseText>
    </FlexCol>
  )
}

KPIBoxV2.Extra = ({ children }) => {
  return <FlexCol gap='0.25rem'>{children}</FlexCol>
}
